import { render, staticRenderFns } from "./RearRightHandlebar.vue?vue&type=template&id=88b81a48"
import script from "./RearRightHandlebar.vue?vue&type=script&lang=js"
export * from "./RearRightHandlebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports